import * as React from "react";

import { SubNav } from "..";
import { connect } from "react-redux";

function EducationNavigation(props) {
  const { useEducationDownloadSection } = props.app;
  return (
    <SubNav
      items={[
        {
          isAvailable: true,
          label: "Education",
          path: "/Portal/education",
        },
        {
          isAvailable: true,
          label: `Cy Intelligence`,
          path: "/Portal/cy-intelligence",
        },
        {
          isAvailable: true,
          label: "Loss Simulator",
          path: "/Portal/loss-simulator",
        },
        ...(useEducationDownloadSection ?
          [{
            isAvailable: true,
            label: "Downloads",
            path: "/Portal/downloads",
          }] : []
        ),
      ]}
      {...props}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    feed: state.feed,
    appName: state.app.appName,
  };
};
export default connect(mapStateToProps)(EducationNavigation);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/EducationNavigation/index.jsx